import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { LoadingService } from '../../shared/services/loading.service';
import { CUSTOM_EVENT_QUERY_PARAM_NAME } from '../utils/http-request-utils';
import { AppConfig } from '../services/app-config.service';
import { AuthStoreService } from '../../shared/services/auth/auth-store.service';
import { DialogService } from '../services/dialog.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  private blackListedUrls = [];
  constructor(
    private router: Router,
    private loadingService: LoadingService,
    private appConfig: AppConfig,
    private authStore: AuthStoreService,
    private dialogService: DialogService,
  ) {
  this.blackListedUrls = [
      `${this.appConfig.config.authUrl}/changePassword`,
      `${this.appConfig.config.authUrl}/verificationCodeValid`,
    ];


  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const eventName = req.params.get(CUSTOM_EVENT_QUERY_PARAM_NAME);
    this.handleCustomEvent(req, eventName);

    return next.handle(req).pipe(
      tap((data) => {
        if (data instanceof HttpErrorResponse) {
          this.checkErrorCode(data);
        }
        if (data instanceof HttpResponse && eventName) {
          this.loadingService.removeEvent(eventName);
        }
      }),
      catchError((data) => {
        if (data instanceof HttpErrorResponse && this.isNotBlacklisted(req)) {
          this.checkErrorCode(data);
          this.checkIfWarning(data);
        }
        return throwError(() => data);
      }),
    );
  }

  private handleCustomEvent(req: HttpRequest<any>, eventName: string): void {
    if (eventName) {
      this.loadingService.event(eventName);
      req.params.delete(eventName);
    }
  }

  private isNotBlacklisted(req: HttpRequest<any>): boolean {
    return !this.blackListedUrls.includes(req.url);
  }

  private checkErrorCode(data: HttpErrorResponse): void {
    if (
      this.authStore?.userInfo &&
      this.authStore?.customerId &&
      (401 === data?.status || (400 === data?.status && data?.url?.includes(this.appConfig?.config?.oauth2?.issuer)))
    ) {
      this.authStore.failedRefreshToken();
    } else if (403 === data.status) {
      this.router.navigate(['/error/403']);
    } else if (404 === data.status) {
      this.router.navigate(['/error/404']);
    } else if (data.status === 451) {
      this.dialogService.openReadOnlyInfoDialog();
    }
  }

  private checkIfWarning(data: HttpErrorResponse): void {
    if ([400, 417, 422].includes(data.status)) {
      console.warn(data.error?.errorCodes || data);
      return;
    }
  }
}
